export default __webpack_public_path__ + "static/media/duck_gray.fadb3084.svg";